import {IconMail } from "@tabler/icons";
import emailcomposer from "../json/emailcomposer";
import rewordoutreachemails from "../json/rewordoutreachemails";
import keywordresearchemail from "../json/keywordresearchemail";

// constant
const icons = {
  IconMail,
};

// ==============================|| EXTRA PAGES MENU ITEMS ||============================== //

const emailmarketing = {
  id: "ppccampaign",
  title: "PPC Campaign",
  caption: "PPC Campaign",
  type: "group",
  children: [
    {
      id: "emailmarketing",
      title: "Email Marketing",
      type: "collapse",
      icon: icons.IconMail,

      children: [
        {
          id: "email-composer",
          title: "Email Composer",
          titleType: "collapse",
          type: "item",
          url: "/email-composer",
          target: false,
          breadcrumbs: true,
          endPoint: "ai/replymail",
          jsonobject: emailcomposer,
          editorTitile: "Email Composer",
          mainTitile: "Email Composer",
          mainDescription: "Create an email that make difference",
        },
        {
          id: "reword-out-reach-emails",
          title: "Reword outreach emails to make them unique",
          titleType: "collapse",
          type: "item",
          url: "/reword-out-reach-emails",
          target: false,
          breadcrumbs: true,
          endPoint: "ai/rephraseemail",
          jsonobject: rewordoutreachemails,
          editorTitile: "Here is your email that has been rephrased.",
          mainTitile: "Reword outreach emails to make them unique",
          mainDescription: "Post your letter to be revised.",
        },

        {
          id: "email-marketing-content",
          title: "Email marketing content for your campaign",
          titleType: "collapse",
          type: "item",
          url: "/email-marketing-content",
          target: false,
          breadcrumbs: true,
          endPoint: "ai/emailmarketing",
          jsonobject: keywordresearchemail,
          editorTitile: "Email marketing content for your campaign",
          mainTitile: "Email Marketing campaign generation",
          mainDescription:
            "This feature enables you to input a product or campaign, and the app will generate email marketing content for your campaign.",
        },
      ],
    },
  ],
};

export default emailmarketing;
